import { get_config as get_config_api } from '@/services'
import Vue from 'vue'
import Router from '@/router/router'
import Store from '@/vuex'
import { custom_event, get_config } from '@/utilities/commons'

// Crea una coda temporanea per le chiamate pending
window.trackSsoEvents = function() {
  window.console.log('[trackSsoEvents] Chiamata ricevuta ma funzione non ancora pronta, messa in coda');
  window.trackSsoEvents._pending = true;
};

export function app_config() {
  let token = ''

  // token as querystring
  if (Router.history.current.query.token) token = Router.history.current.query.token

  // token as state key
  if (token == '') token = Store.state.token

  Store.commit('token', token)

  return get_config_api(token)
    .then((value) => {

      /*
      // debug purpose
      value.guiSettings.customizations = {
        primary: '#7D193F',
        secondary: '#ED9CAD',
        info: '#ED9CAD',
        extra1: '#FFFFFF',
        extra2: '#F8F9FA',
      }
      
      // debug purpose
      value.guiSettings.loginModal = {
        "title": "login modal",
        "msg": "Explicabo aliquam omnis distinctio temporibus ut. Voluptatem facilis eveniet maiores. Assumenda deleniti hic et. Voluptas quos consequatur iure ipsam corrupti possimus quia quidem. Incidunt praesentium tempora ea soluta ducimus fugiat velit. Molestiae modi aut similique repudiandae placeat et."
      }

      // debug purpose
      value.guiSettings.customizations = {
        logo: "https://placehold.co/300x200/CC0000/000000.png",
        logoUrl: "https://www.migitech.it",
        mainLogo: "https://placehold.co/300x200/000000/FFFFFF.png",
        poweredByLogo: "https://placehold.co/300x200/666666/FFFFFF.png",
        poweredByCaption: "custom by",
        colors: {},
      }*/

      Vue.prototype.$config = value

      if (!value) return

      Store.commit('token', value.token)  // per essere sicuri di usare il token che c'è in config
      Store.commit('ext_token', value.extToken)

      // Store.replaceState({})

      if (value.integration == undefined) return

      // se c'è availability la metto nello state
      if (value.integration.availability) Store.commit('availability', value.integration.availability)
      // [codici sconto] implementazione vadobay: se c'è un codice sconto lo metto nello state
      // if (value.integration.loginDiscountCode) Store.commit('discount_codes', [{ discountCode: value.integration.loginDiscountCode }])
      // [codici sconto] implementazione liveflight: se c'è un array di oggetti con i codici sconto li metto nello state
      if (value.integration.loginDiscountCode) Store.commit('discount_codes', value.integration.loginDiscountCodes)
      else Store.commit('discount_codes', [])

      // Funzione per trackare eventi SSO
      function trackSsoEvents() {
        // Usa get_config per accesso sicuro alla configurazione
        const displayName = get_config('integration.displayName', '')
        const email = get_config('integration.email', '')
        const token = get_config('token', '')
        const customer = get_config('integration.customer', '')
        const company = get_config('integration.company', '')
        const availability = get_config('integration.availability', 0)
        const customerDisplayName = get_config('integration.customerDisplayName', '')
        const welfare = get_config('integration.welfare', false)
        const customizationUse = get_config('integration.customizationUse', '')

        if (window.Tawk_API) {

          let tawkAttributes = {
            'name': displayName,
            'email': email,
            'token': token,
            'portale': customer,
            'azienda': company,
            'credito': availability,
          }

          if (window.Tawk_API.setAttributes !== undefined) {

            window.Tawk_API.setAttributes(tawkAttributes, function (error) {

              if (error) {
                window.console.log('tawk setAttributes error')
                window.console.log(error)
              }

            })

          } else {

            window.Tawk_API.onLoad = function () {
              window.Tawk_API.setAttributes(tawkAttributes, function (error) {

                if (error) {
                  window.console.log('tawk onLoad setAttributes error')
                  window.console.log(error)
                }

              })
            }

          }

        }

        if (window.LogRocket) {
          window.LogRocket.identify(email, {
            name: displayName,
            email: email,
            // custom variables
            customer: customer,
            company: company,
            token: token,
          });

          window.LogRocket.track('sso')
        }

        if (window.clarity) {
          window.clarity("set", "token", token)
          window.clarity("set", "customer", customer)
          window.clarity("set", "company", company)
          window.clarity("set", "sso", email)
        }

        custom_event(
          'sso',
          '',
          availability,
          'userBehaviour'
        )

        custom_event(
          'sso',
          customerDisplayName,
          availability,
          'partnerBehaviour'
        )

        custom_event(
          'welfare',
          welfare ? 'welfare' : '',
          welfare ? 1 : 0,
          'partnerBehaviour'
        )

        if (customizationUse) {
          custom_event(
            'customizationUse',
            customizationUse,
            0,
            'partnerBehaviour'
          )
        }

        custom_event(
          'sso',
          company,
          availability,
          'companyBehaviour'
        )

        if (window.fbq) window.fbq('trackCustom', 'Sso', {
          customer: customer,
          company: company,
          availability: availability,
        })
      }

      // Sostituisci la coda temporanea con la funzione vera
      var wasPending = window.trackSsoEvents._pending;
      window.trackSsoEvents = trackSsoEvents;

      // Se c'era una chiamata pending, eseguila ora
      if (wasPending) {
        window.console.log('[trackSsoEvents] Eseguo chiamata pending');
        trackSsoEvents();
      }

    })
}